import axios from "axios";
//import { authTokenCookie } from "../utils/CookieMaker";
import { getNoCacheHeaders } from '../utils/getNoCacheHeaders';
let header = getNoCacheHeaders();
//let { userId } = authTokenCookie();


export const api = (url, methodType, data, token) => {
  header={...header,  "Ocp-Apim-Subscription-Key": `${token}`}

  return axios({
    url: url,
    method: methodType,
    cache: false,
    data: data,
    crossDomain: true,
    headers: header
  })
};

export const nodeApi = (url, methodType, data, token) => {
  return axios({
    url: url,
    method: methodType,
    cache: false,
    crossDomain: true,
    headers: {
      "Content-Type": " application/json",
    },
  })
};


